import React, { Component } from 'react';
import Wrp from "../../hoc/Wrp/Wrp";
import Select from "react-select";
import {setAndGetAttributes} from './FormInputFunctions';
import makeAnimated from "react-select/animated";

class Multiselect extends Component {

   fieldOnChangeHandler = (options,values)=>{
    const {changeHandler} = this.props;
    switch ((values!==undefined)?values.action:'others') {
      case 'remove-value':
        if (values.removedValue.isFixed===true) {
          return;
        }
      case 'pop-value':
        if (values.removedValue.isFixed===true) {
          return;
        }
        break;
      case 'clear':
        options = options.filter((v)=>{
          if(v.isFixed!==true){
            return v;
          }
        })
        break;
    }
    //console.log(options);
    changeHandler(options);
  } 
  
  render() {
    const {value,options} = this.props;
    const animatedComponents = makeAnimated();
    let attr = setAndGetAttributes(this.props);
    //console.log('attr==',attr);
    return (
      
      <Wrp>
        <div className={(this.props.isMandatory && this.props.isMandatory===true)? "mandatory" : "" }>
          <Select 
              isMulti={true}
              classNamePrefix="form-control"
              onChange={e=>this.fieldOnChangeHandler(e)}
              {...attr}
              className=''
              isClearable={false}
              options={options}
              value={value}
              //components={animatedComponents}
          />
        </div>
      </Wrp>        
   );
  }
}

Multiselect.defaultProps = {
  disabled: false,
  readOnly:false,
  className: 'form-control'
}

export default Multiselect;

